import { configureStore, ThunkAction, UnknownAction, ThunkDispatch } from "@reduxjs/toolkit";
import rootReducer, { RootState } from "./rootReducer";

export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, undefined, UnknownAction>;
export type AppThunkGeneric<R> = ThunkAction<
  R,
  RootState,
  undefined,
  UnknownAction
>;

const store = configureStore({
  reducer: rootReducer,
});

// AppDispatch needs to include thunk dispatch capability
export type AppDispatch = ThunkDispatch<RootState, undefined, UnknownAction>;
export type { RootState };

export default store;
